import * as React from 'react';
import { LanguageQualificationForm } from './LanguageQualificationForm';
import { PAGE_TEXT } from '../lang';
import { type LanguageQualificationFormData } from '../../../graphql';
import { Accordion, NotificationText } from '../../../../../components';
import { type FormController } from '../../../../../utils';

type LanguageQualificationProps = {
  applicationNo: string;
  languageQualification: LanguageQualificationFormData;
  enableEdit: FormController;
  refetchApplication: () => void;
  enableDelete: boolean;
  handleLoading: (callback: () => Promise<void>) => Promise<void>;
};

export const LanguageQualification: React.FunctionComponent<
  LanguageQualificationProps
> = props => {
  const {
    QUALIFICATION: { LANGUAGE_QUALIFICATION },
  } = PAGE_TEXT;
  const {
    applicationNo = '',
    languageQualification,
    enableEdit,
    refetchApplication,
    handleLoading,
    enableDelete,
  } = props;

  const details = (
    <LanguageQualificationForm
      applicationNo={applicationNo}
      initialValues={languageQualification}
      enableEdit={enableEdit}
      enableDelete={enableDelete}
      refetchApplication={refetchApplication}
      handleLoading={handleLoading}
    />
  );

  const note = `Please refer to the <a 
  target="_blank"
  href = 'https://www.polyu.edu.hk/study/pg/research-postgraduate/admission-requirements-rpg'>University's English language requirements</a>. 
  `;

  return (
    <>
      <NotificationText note={note} />
      <Accordion
        defaultExpanded
        title={LANGUAGE_QUALIFICATION.LANGUAGE_QUALIFICATION}
        details={details}
      />
    </>
  );
};
